'use client';

import { Button } from '@petsmart-ui/sparky';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormFields } from '@/entities/purchase-form';
import { BaseDrawer } from '@/shared/ui';

import { useHasOnlyPersonalizationErrors, useIsFormValid } from '../../model';
import { InputLines } from './InputLines';
import './PersonalizationFields.scss';

type PersonalizationFieldsProps = {
    renderSubmitButton: ReactNode;
};

export const PersonalizationFields = ({ renderSubmitButton }: PersonalizationFieldsProps) => {
    const { formState } = useFormContext<FormFields>();
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const submitCountRef = useRef(0);

    useEffect(() => {
        if (isDrawerOpen && formState.submitCount > submitCountRef.current) {
            setDrawerOpen(false);
            submitCountRef.current = formState.submitCount;
        }
    }, [isDrawerOpen, formState.submitCount]);

    const { isValid } = useIsFormValid();
    const { hasOnlyPersonalizationErrors } = useHasOnlyPersonalizationErrors();

    return (
        <div className="personalization-fields">
            <Button
                size="lg"
                fullWidth
                type="button"
                variant="primary"
                text="Personalize"
                disabled={!hasOnlyPersonalizationErrors && !isValid}
                data-testid="personalization-button"
                onClick={() => setDrawerOpen(true)}
            />
            <BaseDrawer
                isOpen={isDrawerOpen}
                title="Personalize Item"
                className="personalization-drawer"
                testId="personalization-fields-drawer"
                onCloseAction={() => setDrawerOpen(false)}
            >
                <InputLines name="frontLines" />
                <InputLines name="backLines" />
                {renderSubmitButton}
            </BaseDrawer>
        </div>
    );
};
